/**
 * Veridex Protocol SDK - Aptos Chain Module  
 */

export { AptosClient } from './AptosClient.js';
export type { AptosClientConfig } from './AptosClient.js';
